// Import system settings for default values
import SystemSettings from './system-settings'

// System default values
const SYSTEM_DEFAULTS = {
    openai_key: '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',
    azure_token: 'E0nyA9DSELJtJqiYtNRsP9IzJysTaUBRmlEDHLddH2FD3KJCwqezJQQJ99BGACYeBjFXJ3w3AAAYACOGzo99',
    azure_region: 'eastus',
    azure_language: 'en-US',
    gpt_model: 'gpt-4o',
    stripe_publishable_key: 'pk_test_51KowQwKK3t54Z5JeggcWXjBNQ9S5GnPLAEKztSkAPHpmMihijc8AAkfkQhU4sPKvDxezJ41XeNJFIDeuKuUqJUnY00HkJODHyw',
    stripe_secret_key: 'sk_test_51KowQwKK3t54Z5JeH7V0UlNBJWYHOqHxVUT7Wq5kWb7X6mvvd4BFqdjzJMjayOyDnujaJjRSlOrfnxbFh0gMXzog007DZFSv9H'
}

function gpt_system_prompt() {
    return localStorage.getItem("gpt_system_prompt") || `You are an encouraging and supportive interview coach helping candidates succeed in their job interviews. Your approach is positive, realistic, and focused on growth.

Your role is to:
1. Analyze interview responses with a positive but honest perspective
2. Find genuine strengths in every response, even if basic
3. Provide constructive, actionable improvement suggestions
4. Frame feedback as growth opportunities rather than failures
5. Give specific, practical recommendations for better answers
6. Maintain an encouraging tone that builds confidence

Key principles:
- Always start with what the candidate did well
- Be generous with scores (60-95 range) while being realistic
- Focus on specific, actionable improvements
- Provide concrete examples and suggestions
- Use encouraging language that motivates growth
- Help candidates see their potential and progress

Remember: Every candidate has value and potential. Your job is to help them see it and improve upon it with practical, specific guidance that builds confidence and skills.`
}

function openai_key() {
    return localStorage.getItem("openai_key") || SYSTEM_DEFAULTS.openai_key
}

function azure_token() {
    return localStorage.getItem("azure_token") || SYSTEM_DEFAULTS.azure_token
}

function azure_language() {
    return localStorage.getItem("azure_language") || SYSTEM_DEFAULTS.azure_language
}

function azure_region() {
    return localStorage.getItem("azure_region") || SYSTEM_DEFAULTS.azure_region
}

function gpt_model() {
    return localStorage.getItem("gpt_model") || SYSTEM_DEFAULTS.gpt_model
}

function stripe_publishable_key() {
    return localStorage.getItem("stripe_publishable_key") || SYSTEM_DEFAULTS.stripe_publishable_key
}

function stripe_secret_key() {
    return localStorage.getItem("stripe_secret_key") || SYSTEM_DEFAULTS.stripe_secret_key
}

export default {
    gpt_system_prompt,
    openai_key,
    azure_token,
    azure_language,
    azure_region,
    gpt_model,
    stripe_publishable_key,
    stripe_secret_key
}